import Vue from 'vue';
import Component from 'vue-class-component';
import template from './table-status-message.html';

@Component({ template })
export class TableStatusMessage extends Vue {}

Vue.component('table-status-message', TableStatusMessage);
